import React, { Component } from 'react';

import { trans } from '../../../../../localization/index';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../../components/Table/PageTable';
import { EnumCommonStatus, EnumPagingMode } from '../../../../../constants/enum';

class RestaurantWalletTable extends Component {
  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('merchant_wallet_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'restaurant',
        label: trans('merchant_wallet_header_restaurant'),
        width: '35%',
        textAlign: 'left',
      },
      {
        id: 'address',
        label: trans('merchant_wallet_header_address'),
        width: '40%',
        textAlign: 'left',
      },
      {
        id: 'status',
        label: trans('merchant_wallet_header_status_active'),
        width: '10%',
        textAlign: 'center',
      },
      {
        id: 'control',
        label: trans('merchant_wallet_header_control'),
        width: '10%',
        textAlign: 'center',
      },
    ];

    return <PageTableHeader columns={columns} />;
  }

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={5}>
          {trans('merchant_wallet_not_find_restaurant')}
        </PageTableCell>
      </PageTableRow>
    );
  }

  removeRestaurantUserWallet = (restaurantId) => {
    const { removeRestaurantUserWallet, airpayStoreId } = this.props;
    const reqData = {
      airpay_store_id: airpayStoreId,
      restaurant_id: restaurantId,
    };
    removeRestaurantUserWallet(reqData);
  };

  renderRow = (row, index) => {
    const {
      restaurant_id: restaurantId, name, address, status,
    } = row;

    return (
      <PageTableRow key={restaurantId}>
        <PageTableCell textAlign="center">{index}</PageTableCell>
        <PageTableCell textAlign="left">{name}</PageTableCell>
        <PageTableCell textAlign="left">
          <span className="font12">{address}</span>
        </PageTableCell>
        <PageTableCell textAlign="center">
          {status === EnumCommonStatus.ACTIVE.id && (
            <i className="far fa-check-circle" />
          )}
        </PageTableCell>
        <PageTableCell textAlign="center">
          <button
            type="button"
            className="btn btn-white btn-row-wallet text-red-important"
            onClick={() => this.removeRestaurantUserWallet(restaurantId)}
          >
            {/* <i className="fa fa-times pr-10" /> */}
            {trans('merchant_wallet_restaurant_delete')}
          </button>
        </PageTableCell>
      </PageTableRow>
    );
  };

  render() {
    const { table, changeActivePage, changePageSize } = this.props;
    return (
      <PageTable
        paginationMode={EnumPagingMode.SELF_PAGING.id}
        renderHeader={RestaurantWalletTable.renderHeader}
        renderRow={this.renderRow}
        table={table}
        renderEmpty={RestaurantWalletTable.renderEmpty}
        changeActivePage={changeActivePage}
        changePageSize={changePageSize}
      />
    );
  }
}
export default RestaurantWalletTable;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/RestaurantWallet/components/RestaurantWalletTable.jsx